/*
 *  From Auth0 example
 */
import {createBrowserHistory} from 'history';

export default createBrowserHistory();
